<template>
  <div class="commentMan"></div>
</template>

<script>
export default {
  name: "commentMan",
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {
    this.$parent.resetHeightFn();
  },
  beforeCreate() {}
};
</script>
<style lang='scss' scoped>
.commentMan {
  width: 100%;
  min-height: 650px;
  background: url("../../assets/images/404.png") no-repeat center;
  background-size: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/index/commentMan.vue